import { FormattedMessage } from 'react-intl';

import messages from './NextRepaymentSummary.messages';
import { FormattedCurrency } from '../../../iwIntlProvider/FormattedCurrency';
import RepaymentSummaryItem from '../repaymentSummaryItem/RepaymentSummaryItem';

export const NextRepaymentSummary = ({
    previousNextRepayment,
    interval,
    date,
    amount
}: {
    previousNextRepayment: number | null;
    interval?: string;
    date: string | null;
    amount: number | null;
}) => {
    const renderDescription = () => {
        if (amount === null) {
            return <FormattedMessage {...messages.noFurtherRepayments} />;
        }

        if (previousNextRepayment) {
            return (
                <FormattedMessage
                    {...messages.reducedDescription}
                    values={{
                        amount: (
                            <FormattedCurrency value={previousNextRepayment} />
                        )
                    }}
                />
            );
        }

        return <FormattedMessage {...messages.sameDescription} />;
    };

    return (
        <RepaymentSummaryItem
            amount={amount}
            description={renderDescription()}
            interval={interval}
            value={date}
        />
    );
};
